import { useState } from 'react';
import type { Page } from './useLaunchWizard.ts';

export function PagePicker({ pages, value, onChange, placeholder = 'Fan Page' }: {
  pages: Page[]; value: string; onChange: (id: string) => void; placeholder?: string;
}) {
  const [query, setQuery] = useState('');
  const normalized = query.trim().toLocaleLowerCase();
  const filtered = pages.filter((page) => page.id === value || `${page.name ?? ''} ${page.id}`.toLocaleLowerCase().includes(normalized));
  return <div className="page-picker">
    <input className="input" type="search" aria-label="Search Fan Pages by name or ID" placeholder="Search pages by name or ID" value={query} onChange={(event) => setQuery(event.target.value)} />
    <select className="input" aria-label={placeholder} value={value} onChange={(event) => onChange(event.target.value)}>
      <option value="">{placeholder}</option>
      {filtered.map((page) => <option key={page.id} value={page.id}>{page.name ?? page.id} ({page.id})</option>)}
    </select>
    {normalized && !filtered.length && <small className="text-muted">No matching pages</small>}
  </div>;
}
